export default __webpack_public_path__ + "static/179-674584dacb32e66af1fb0e9f2e2ab9bf.gif";